module.exports = __webpack_public_path__ + "img/talk-2.852a9a97.png";